export const normalizeAgentId = (raw: string | null) => {
  if (!raw) return null;
  const trimmed = raw.trim();
  if (!trimmed) return null;

  const agentWithoutPrefix = trimmed.replace(/^va/i, "");
  const digitsOnly = agentWithoutPrefix.replace(/\D/g, "");
  if (!digitsOnly) return null;

  const padded = digitsOnly.padStart(10, "0");
  return `VA${padded}`;
};
